import { getStates } from '@paperstac/common/lib/services/states';
import DescriptionGridCell from '@paperstac/ui/lib/DescriptionGridCell';
import ErrorText from '@paperstac/ui/lib/ErrorText';
import Flex from '@paperstac/ui/lib/Flex';
import Description from '@paperstac/ui/lib/form/Description';
import Input from '@paperstac/ui/lib/form/Input';
import NumberInput from '@paperstac/ui/lib/form/NumberInput';
import Select from '@paperstac/ui/lib/form/Select';
import Heading from '@paperstac/ui/lib/Heading';
import { ErrorMessage, Field } from 'formik';
import React from 'react';

const CreateSingleListingFormSection = React.memo(({ stacked }) => (
  <>
    <DescriptionGridCell>
      <Heading>Note Details</Heading>
    </DescriptionGridCell>
    <DescriptionGridCell term="Lien Position" as="label">
      <Field name="notes[0].lienPosition" component={NumberInput} sx={{ maxWidth: 50 }} />
      <ErrorMessage name="notes[0].lienPosition" component={ErrorText} />
    </DescriptionGridCell>
    <Flex flexDirection={stacked ? 'column' : 'row'}>
      <DescriptionGridCell term="Property Street Address" as="label" sx={{ borderRight: stacked ? 'none' : 'default' }}>
        <Field name="notes[0].streetAddress1" component={Input} />
        <ErrorMessage name="notes[0].streetAddress1" component={ErrorText} />
      </DescriptionGridCell>
      <DescriptionGridCell term="Address Line 2" as="label" sx={{ flex: stacked ? '1 1 0' : '0 0 170px' }}>
        <Field name="notes[0].streetAddress2" component={Input} />
        <Description color="darkBlue">Apt, Suite, Unit, etc</Description>
        <ErrorMessage name="notes[0].streetAddress2" component={ErrorText} />
      </DescriptionGridCell>
    </Flex>
    <Flex flexDirection={stacked ? 'column' : 'row'}>
      <DescriptionGridCell term="City" as="label" sx={{ borderRight: stacked ? 'none' : 'default' }}>
        <Field name="notes[0].city" component={Input} />
        <ErrorMessage name="notes[0].city" component={ErrorText} />
      </DescriptionGridCell>
      <DescriptionGridCell term="State" as="label" sx={{ borderRight: stacked ? 'none' : 'default' }}>
        <Field name="notes[0].state" component={Select} autoComplete="address-level1">
          <option value="">Choose a state...</option>
          {getStates().map(({ code, name }) => (
            <option key={code} value={code}>
              {name}
            </option>
          ))}
        </Field>
        <ErrorMessage name="notes[0].state" component={ErrorText} />
      </DescriptionGridCell>
      <DescriptionGridCell term="Zip Code" as="label" sx={{ flex: stacked ? '1 1 0' : '0 0 150px' }}>
        <Field name="notes[0].zip" component={Input} inputMode="numeric" />
        <ErrorMessage name="notes[0].zip" component={ErrorText} />
      </DescriptionGridCell>
    </Flex>
  </>
));

CreateSingleListingFormSection.propTypes = {};

CreateSingleListingFormSection.defaultProps = {};

CreateSingleListingFormSection.displayName = 'CreateSingleListingFormSection';

export default CreateSingleListingFormSection;
